/* eslint-disable camelcase */
import { getBackVersion } from '../config';
import {
    AgentSnapshot,
    BalanceSnapshot,
    UpdateAgentDataFields,
} from '../models';
import api from './api';

const getAgent = (): Promise<AgentSnapshot> =>
    api.request<AgentSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/account/agent`,
    });

const getBalance = (): Promise<BalanceSnapshot> =>
    api.request<BalanceSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/agent/points`,
    });

const patch = ({
    avatarS3Path,
    avatarFilename,
}: UpdateAgentDataFields): Promise<AgentSnapshot> =>
    api.request<AgentSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/account/agent`,
        data: {
            avatar_s3_path: avatarS3Path,
            avatar_filename: avatarFilename,
        },
    });

export default {
    getAgent,
    getBalance,
    patch,
};
